/* NECES Quote Cart — draft-order backend with email fallback
   Submits to Apps Script endpoint (window.NCQuote.quoteEndpoint).
   On any error/timeout, falls back to native Liquid contact form email. */
(function() {
  'use strict';
  if (!window.location.pathname.includes('/cart')) return;

  /* ---- 1. Email fallback redirect (native form POST lands here) ---- */
  if (window.location.search.indexOf('contact_posted=true') !== -1) {
    showEmailConfirmation();
    return;
  }

  /* ---- 2. Hide prices — layered, skips form + confirmation ---- */
  function hidePrices() {
    var selectors = [
      '.cart-page .price',
      '.cart-page [class*="price"]',
      '.cart-page .money',
      '.cart-page cart-item-price',
      '.cart-page .cart-item__price',
      '.cart-page .cart-summary',
      '.cart-page [class*="subtotal"]',
      '.cart-page [class*="total"]',
      '.cart-page [name="checkout"]',
      '.cart-page [class*="checkout"]',
      '.cart-page .cart-discount',
      '.cart-page [class*="discount"]'
    ];
    document.querySelectorAll(selectors.join(',')).forEach(function(el) {
      if (el.closest('.nc-quote-form-wrapper')) return;
      if (el.closest('.nc-quote-confirmation')) return;
      el.style.display = 'none';
    });

    document.querySelectorAll('.cart-page span, .cart-page div, .cart-page p').forEach(function(el) {
      if (el.closest('.nc-quote-form-wrapper')) return;
      if (el.closest('.nc-quote-confirmation')) return;
      var t = el.textContent.trim();
      if (/^\$[0-9]/.test(t) && !el.querySelector('*')) {
        el.style.display = 'none';
      }
    });

    var scope = document.querySelector('.content-for-layout') || document;
    scope.querySelectorAll('[class*="product-list"] .price, [class*="product-list"] [class*="price"]').forEach(function(el) {
      el.style.display = 'none';
    });
  }

  /* ---- 3. Collapse price column ---- */
  function injectPriceColumnCollapse() {
    var s = document.createElement('style');
    s.textContent = '.cart-page .cart-items__table-row{--cart-item-price-width:0px!important;}';
    document.head.appendChild(s);
  }

  /* ---- 4. Responsive layout (3fr 2fr desktop, stacked mobile) ---- */
  function applyLayout() {
    var page = document.querySelector('.cart-page');
    if (!page) return;
    var title = page.querySelector('.cart-page__title');
    var items = page.querySelector('.cart-page__items');
    var summary = page.querySelector('.cart-page__summary');

    if (window.innerWidth >= 750) {
      page.style.cssText = 'display:grid!important;grid-template-columns:3fr 2fr!important;grid-template-rows:auto 1fr!important;gap:0 48px!important;align-items:start!important;';
      if (title)   title.style.cssText   = 'grid-column:1/-1!important;grid-row:1!important;';
      if (items)   items.style.cssText   = 'grid-column:1!important;grid-row:2!important;';
      if (summary) summary.style.cssText = 'grid-column:2!important;grid-row:2!important;position:sticky!important;top:120px!important;align-self:start!important;display:block!important;height:auto!important;padding-top:0!important;';
    } else {
      page.style.cssText = 'display:block!important;';
      if (title)   title.style.cssText   = '';
      if (items)   items.style.cssText   = '';
      if (summary) summary.style.cssText = 'position:static!important;display:block!important;margin-top:24px!important;width:100%!important;padding-top:0!important;';
    }
  }

  /* ---- 5. Badge update ---- */
  function updateBadge() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var badge = document.querySelector('.nc-hdr__cart-count');
        if (badge) {
          badge.textContent = cart.item_count;
          if (cart.item_count > 0) badge.removeAttribute('hidden');
          else badge.setAttribute('hidden', '');
        }
      });
  }

  /* ---- 6. Quote item count ---- */
  function updateQuoteCount() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var count = document.getElementById('nc-quote-count');
        if (count) {
          count.innerHTML = '<strong>' + cart.item_count + ' item' + (cart.item_count !== 1 ? 's' : '') + ' in your quote</strong>';
        }
      });
  }

  /* ---- 7. Build product list for email fallback hidden field ---- */
  function buildBody(cart) {
    return cart.items.map(function(item, i) {
      return (i + 1) + '. ' + item.title +
        (item.variant_title ? ' (' + item.variant_title + ')' : '') +
        ' | SKU: ' + (item.sku || 'N/A') +
        ' | Qty: ' + item.quantity;
    }).join('\n');
  }

  /* ---- 8. Form submit: draft-order endpoint with email fallback ---- */
  function setupQuoteSubmit() {
    var form = document.querySelector('form.nc-quote-form');
    if (!form || form.dataset.ncWired) return;
    form.dataset.ncWired = 'true';

    form.addEventListener('submit', function(e) {
      e.preventDefault();
      if (!form.checkValidity()) { form.reportValidity(); return; }

      var btn = form.querySelector('.nc-quote-form-submit');
      if (!btn || btn.disabled) return;
      btn.disabled = true;
      btn.textContent = 'Submitting\u2026';

      var endpoint = window.NCQuote && window.NCQuote.quoteEndpoint;
      var secret = window.NCQuote && window.NCQuote.quoteSecret;

      if (!endpoint || endpoint.indexOf('PASTE') !== -1) {
        emailFallback(form, btn);
        return;
      }

      fetch('/cart.js')
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          if (!cart.items || cart.items.length === 0) {
            btn.textContent = 'Your quote is empty';
            setTimeout(function() { btn.textContent = 'Submit Quote Request'; btn.disabled = false; }, 2000);
            return Promise.reject('empty');
          }

          // Populate the email-fallback hidden field NOW, while we hold the cart.
          // Guarantees the fallback email always carries the product list.
          var hfBody = document.getElementById('nc-hf-body');
          if (hfBody) hfBody.value = buildBody(cart);

          var payload = {
            secret: secret,
            contact: {
              name: form.querySelector('#nc-name').value,
              email: form.querySelector('#nc-email').value,
              phone: form.querySelector('#nc-phone').value,
              business: form.querySelector('#nc-business').value,
              notes: form.querySelector('#nc-notes').value
            },
            lineItems: cart.items.map(function(item) {
              return { variant_id: item.variant_id, quantity: item.quantity, title: item.title };
            }),
            cartSubtotal: cart.items_subtotal_price
          };

          return Promise.race([
            fetch(endpoint, {
              method: 'POST',
              headers: { 'Content-Type': 'text/plain;charset=utf-8' },
              body: JSON.stringify(payload)
            }),
            new Promise(function(_, reject) {
              setTimeout(function() { reject(new Error('timeout')); }, 30000);
            })
          ]);
        })
        .then(function(res) {
          if (!res || typeof res.text !== 'function') return Promise.reject('no-response');
          return res.text().then(function(raw) {
            try { return JSON.parse(raw); }
            catch (e) {
              console.error('Quote backend: unparseable response:', raw.slice(0, 300));
              return Promise.reject('bad-json');
            }
          });
        })
        .then(function(result) {
          if (result && result.status === 'success') {
            fetch('/cart/clear.js', { method: 'POST' })
              .then(function() {
                updateBadge();
                showDraftOrderConfirmation(result.draftOrderName);
              });
          } else {
            console.error('Quote backend error:', result && result.message);
            emailFallback(form, btn);
          }
        })
        .catch(function(err) {
          if (err === 'empty') return;
          console.error('Quote submit error, falling back to email:', err);
          emailFallback(form, btn);
        });
    });
  }

  /* ---- 9. Email fallback — populate hidden field, native submit ---- */
  function emailFallback(form, btn) {
    if (btn) btn.textContent = 'Sending via email\u2026';
    // nc-hf-body is populated synchronously at submit time; just ensure non-empty then go.
    var body = document.getElementById('nc-hf-body');
    if (body && !body.value) {
      fetch('/cart.js')
        .then(function(r) { return r.json(); })
        .then(function(cart) { body.value = buildBody(cart); form.submit(); })
        .catch(function() { form.submit(); });
    } else {
      form.submit();
    }
  }

  /* ---- 10. Draft order confirmation ---- */
  function showDraftOrderConfirmation(draftOrderName) {
    var page = document.querySelector('.cart-page');
    if (!page) return;

    var title = page.querySelector('.cart-page__title');
    var items = page.querySelector('.cart-page__items');
    var summary = page.querySelector('.cart-page__summary');

    if (title) {
      title.innerHTML = '<h2 style="font-size:24px;font-weight:700;color:#1a1a1a;margin:0;">Quote ' + draftOrderName + ' Submitted</h2>';
    }
    if (items) {
      items.innerHTML = '<div class="nc-quote-confirmation">' +
        '<p>Thanks! We\'ve received your quote request and will get back to you within 24 hours with our best price.</p>' +
        '<p style="font-weight:600;font-size:16px;color:#1a1a1a;margin-bottom:24px;">Your reference: ' + draftOrderName + '</p>' +
        '<div class="nc-quote-confirm-actions">' +
          '<button type="button" class="nc-confirm-btn nc-confirm-btn--primary" id="nc-continue">Continue Browsing</button>' +
        '</div></div>';
    }
    if (summary) summary.style.cssText = 'display:none!important;';

    page.style.cssText = 'display:block!important;max-width:600px!important;margin:0 auto!important;text-align:center!important;padding:40px 20px!important;';

    document.getElementById('nc-continue').addEventListener('click', function() {
      window.location.href = '/collections';
    });
  }

  /* ---- 11. Email fallback confirmation (native redirect) ---- */
  function showEmailConfirmation() {
    function render() {
      var page = document.querySelector('.cart-page');
      if (!page) { setTimeout(render, 100); return; }
      page.style.cssText = 'display:block!important;text-align:center;padding:60px 20px;max-width:600px;margin:0 auto;';
      page.innerHTML =
        '<div class="nc-quote-confirmation">' +
          '<h3 style="color:#1a6847;font-size:20px;margin:0 0 8px;">Quote Request Sent</h3>' +
          '<p>Thanks! We\'ve received your quote request and will get back to you within 24 hours with our best price.</p>' +
          '<div class="nc-quote-confirm-actions">' +
            '<button type="button" class="nc-confirm-btn nc-confirm-btn--primary" id="nc-new-quote">Start a New Quote</button>' +
            '<button type="button" class="nc-confirm-btn nc-confirm-btn--secondary" id="nc-keep-browsing">Continue Browsing</button>' +
          '</div>' +
        '</div>';

      document.getElementById('nc-new-quote').addEventListener('click', function() {
        fetch('/cart/clear.js', { method: 'POST' }).then(function() {
          var badge = document.querySelector('.nc-hdr__cart-count');
          if (badge) { badge.textContent = '0'; badge.setAttribute('hidden', ''); }
          window.location.href = '/collections';
        }).catch(function() { window.location.href = '/collections'; });
      });
      document.getElementById('nc-keep-browsing').addEventListener('click', function() {
        window.location.href = '/collections';
      });
    }
    render();
  }

  /* ---- Init ---- */
  function init() {
    hidePrices();
    injectPriceColumnCollapse();
    applyLayout();
    updateQuoteCount();
    setupQuoteSubmit();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* MutationObserver for late price renders + cart re-renders */
  var mutationTimer;
  var observer = new MutationObserver(function() {
    hidePrices();
    clearTimeout(mutationTimer);
    mutationTimer = setTimeout(function() {
      applyLayout();
      setupQuoteSubmit();
      updateBadge();       // sync header badge after deletes/qty changes
      updateQuoteCount();  // keep the form's item count current
    }, 150);
  });
  observer.observe(document.body, { childList: true, subtree: true });

  /* setInterval backstop — self-terminates after 5s */
  var hideInterval = setInterval(hidePrices, 500);
  setTimeout(function() { clearInterval(hideInterval); }, 5000);

  /* Resize listener */
  var resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(applyLayout, 150);
  });
})();
